import type { ReactNode } from "react";
import type { WarehousePlaceResource } from "@exonn/js-sdk";
import { Select } from "src/components/Select/Select.tsx";
import { useSelect } from "src/system/useSelect.tsx";
import { ResourceEnum } from "src/constants/constants.ts";

// Lagerplatz выбранного склада.
export const PlaceSelect = ({
  warehouseId,
  value,
  onChange,
  label,
  placeholder,
}: {
  warehouseId: string;
  value: string;
  onChange: (value: string) => void;
  label?: ReactNode;
  placeholder?: string;
}) => {
  const { options } = useSelect<WarehousePlaceResource>({
    resource: ResourceEnum.WarehousePlace,
    labelProp: "title",
    filter: {
      items: [{ field: "warehouse_id", operator: "is", value: warehouseId }],
    },
  });

  return (
    <Select
      label={label}
      value={value}
      onChange={(next) => onChange(next ?? "")}
      options={options}
      placeholder={placeholder}
      showSearch
    />
  );
};
